import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { mainNav, siteConfig } from '@/mocks/site';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-background-50/70 backdrop-blur'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-content items-center justify-between px-4 md:h-20 md:px-6">
        <Link to="/" className="flex items-center gap-3" aria-label={`${siteConfig.name} 首页`}>
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-file-shield-2-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              {siteConfig.name}
            </span>
            <span className="hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">
              反诈内幕档案库
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {mainNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/about"
            className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 md:inline-flex"
          >
            提交线索
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-content flex-col px-4 py-4" aria-label="移动端导航">
            {mainNav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-base font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-800 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about"
              onClick={() => setMenuOpen(false)}
              className="mt-2 rounded-md bg-foreground-950 px-4 py-3 text-center text-base font-medium text-background-50"
            >
              提交线索
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}